import styled from 'styled-components';
import { BaseTagStyles } from './styles/baseTagStyles';
import type { STagProps } from './Tag';

export interface ManufacturerApprovedProps {
  manufacturer: string;
}

const Tag = styled.div<Pick<STagProps, 'variant'>>`
  ${BaseTagStyles};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARK};
  background: ${({ theme }) => theme.donedeal.colors.GREY_LIGHTER};
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.bold};
`;

function ManufacturerApproved({ manufacturer }: ManufacturerApprovedProps) {
  return <Tag variant="DEFAULT">{manufacturer} Approved</Tag>;
}

export { ManufacturerApproved };
